<div class="wrapper pt-[40px]">
  @if (changeOrderMode !== 'direct') {
    <div class="header-section flex justify-start items-start gap-[32px]">
      @for (header of headersList; track header) {
        <div
          (click)="selectHeader(header)"
          [class.selected]="selectedTabId === header?.id"
          class="header text-type-3 cursor-pointer text-[#60698B]"
          >
          {{ header.label }}
        </div>
      }
    </div>
  }

  <div class="content-section">
    @switch (selectedTabId) {
      @case (0) {
        @if (!isContractorMode && !displayActivityCodes) {
          <app-bid-items-list
            class="tab-content"
            />
        }
      }
      @case (2) {
        <app-change-in-work-request-wrapper
          class="tab-content"
          />
      }
      @case (1) {
        <app-change-orders-request-wrapper
          class="tab-content"
          />
      }
    }
  </div>
</div>
